import base from './configService'

const fichajeServices = {}

fichajeServices.getUltimosFichajes = function (id) {
    return base.get('/Marks/' + id)
      .then(res => {
        return res.data;
      })
      .catch(e => {
        return Promise.reject(e);
      })
}

fichajeServices.getFichajes = function (dataFindMark) {
  return base.post('/FindMarks/', dataFindMark)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      return Promise.reject(e);
    })
}

fichajeServices.fichar = function (dataFichaje) {
  return base.post('/Marks', dataFichaje)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      return Promise.reject(e);
    })
}

export default fichajeServices